var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        visible: _vm.visible,
        id: "admin-strain-add-modal",
        title: "Add New Strain",
        "hide-footer": "",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Strain Name" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", state: _vm.fieldValid("name") },
                model: {
                  value: _vm.formData.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.name",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("name") } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.formValidation.name) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                type: "submit",
                variant: "success",
                disabled: _vm.formState.processing,
              },
            },
            [
              _vm._v("\n      Submit\n      "),
              _vm.formState.processing
                ? _c("b-spinner", { staticClass: "ml-1", attrs: { small: "" } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              attrs: { type: "button", variant: "secondary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }